// Final Popup

// import React, { useContext, useState } from "react";
// import { UserContext } from "../../../UserContext";
// import { X } from "lucide-react"; // using lucide for close icon
// import img1 from "../../../assets/hitws1.png";

// const TitleSelectionPopup = ({ titles = [], story_id, onClose }) => {
//   const [customTitle, setCustomTitle] = useState("");
//   const [selectedTitle, setSelectedTitle] = useState("");
//   const { user } = useContext(UserContext);

//   const handleSave = async () => {
//     const finalTitle = customTitle.trim() || selectedTitle.trim();
//     if (!finalTitle) return;
//     updateTitle(finalTitle);
//     onClose(finalTitle);
//   };

//   const updateTitle = async (title) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_selected_title`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             userid: user.user_id,
//             story_id: story_id,
//             chapter_id: null,
//             title: title,
//           }),
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error("Failed to update title:", errorData.detail || errorData);
//         return;
//       }

//       const result = await response.json();
//       console.log("Title updated successfully:", result);
//     } catch (error) {
//       console.error("Error updating title:", error);
//     }
//   };

//   const handleCustomChange = (val) => {
//     setCustomTitle(val);
//     setSelectedTitle(""); // Clear selected if typing custom
//   };

//   const handleSelectTitle = (title) => {
//     setSelectedTitle(title);
//     setCustomTitle(""); // Clear custom if selecting from options
//   };

//   return (
//     <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
//       <div className="bg-white rounded-2xl shadow-xl p-6 w-[90%] max-w-2xl max-h-[90vh] overflow-y-auto relative">
//         {/* Close icon */}
//         <button
//           onClick={() => onClose("")}
//           className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
//         >
//           <X size={20} />
//         </button>

//         {/* Header with text and image */}
//         <div className="flex items-center justify-between mb-6">
//           <h2 className="text-xl font-semibold text-gray-800">
//             Pick a title for the knot you want to unravel
//           </h2>
//           <img
//             src={img1} // placeholder image replace the image by the STO
//             alt="Illustration"
//             className="w-16 h-16 mr-10"
//           />
//         </div>

//         {/* Title options */}
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
//           {titles.slice(0, 4).map((item, idx) => {
//             const isActive = selectedTitle === item.title;
//             return (
//               <button
//                 key={idx}
//                 onClick={() => handleSelectTitle(item.title)}
//                 className={`px-4 py-3 text-sm rounded-xl text-center border transition-all h-[80px] flex items-center justify-center text-gray-700 font-medium
//                   ${
//                     isActive
//                       ? "border-[#54B0AF] bg-[#e3f6f5]"
//                       : "border-gray-300 hover:border-[#469a99]"
//                   }`}
//               >
//                 {item.title}
//               </button>
//             );
//           })}
//         </div>

//         {/* Custom input */}
//         <div className="mb-4">
//           <input
//             type="text"
//             value={customTitle}
//             onChange={(e) => handleCustomChange(e.target.value)}
//             placeholder="No One Undersatnd Your Threads Better Then You..."
//             className="w-full px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#54B0AF] text-sm"
//           />
//         </div>

//         {/* Save Button */}
//         <button
//           onClick={handleSave}
//           disabled={!customTitle.trim() && !selectedTitle.trim()}
//           className={`w-full mt-2 py-2 rounded-xl transition text-white font-semibold ${
//             customTitle.trim() || selectedTitle.trim()
//               ? "bg-[#54B0AF] hover:bg-[#469a99]"
//               : "bg-gray-300 text-gray-500 cursor-not-allowed"
//           }`}
//         >
//           Save Title
//         </button>
//       </div>
//     </div>
//   );
// };

// export default TitleSelectionPopup;

// My Changes

// import React, { useContext, useState } from "react";
// import { UserContext } from "../../../UserContext";
// import { X } from "lucide-react";
// import PandaTitleSelection from "../../../assets/PandaTitleSelection.png";

// const TitleSelectionPopup = ({ titles = [], story_id, onClose }) => {
//   const [customTitle, setCustomTitle] = useState("");
//   const [selectedTitle, setSelectedTitle] = useState("");
//   const { user } = useContext(UserContext);

//   const handleSave = async () => {
//     const finalTitle = customTitle.trim() || selectedTitle.trim();
//     if (!finalTitle) return;
//     updateTitle(finalTitle);
//     onClose(finalTitle);
//   };

//   const updateTitle = async (title) => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_selected_title`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             userid: user.user_id,
//             story_id: story_id,
//             chapter_id: null,
//             title: title,
//           }),
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error("Failed to update title:", errorData.detail || errorData);
//         return;
//       }

//       const result = await response.json();
//       console.log("Title updated successfully:", result);
//     } catch (error) {
//       console.error("Error updating title:", error);
//     }
//   };

//   const handleCustomChange = (val) => {
//     setCustomTitle(val);
//     setSelectedTitle("");
//   };

//   const handleSelectTitle = (title) => {
//     setSelectedTitle(title);
//     setCustomTitle("");
//   };

//   return (
//     <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
//       <div className="bg-white rounded-2xl shadow-xl  w-[940px] max-w-4xl max-h-[640px] relative">
//         {/* Close icon */}
//         <button
//           onClick={() => onClose("")}
//           className="absolute top-4 right-4 text-gray-500 font-bold hover:text-gray-600 z-10"
//         >
//           <X size={20} className="font-bold" />
//         </button>

//         <div className="flex">
//           {/* Left - Panda */}
//           {/* <div className="w-[31%] bg-gray-100 rounded-l-2xl flex items-center pt-8">
//             <img
//               src={PandaTitleSelection}
//               alt="Panda Illustration"
//               className="w-full h-auto max-w-[280px] bg-cover"
//             />
//           </div> */}
//           <div className="max-w-[320px] w-full h-[640px] bg-gray-100 rounded-l-2xl flex items-center justify-center pt-8">
//             <img
//               src={PandaTitleSelection}
//               alt="Panda Illustration"
//               className="max-h-[480px] w-auto object-contain md:translate-y-0"
//             />
//           </div>

//           {/* Right content */}
//           <div className="max-w-[620px] h-[640px] w-full p-8 overflow-y-auto scrollbar-hide">
//             {/* Header */}
//             <div className="mb-6 border-b-2 pb-4 border-[#CACACA]">
//               <h2 className="text-xl sm:text-2xl font-gotham font-medium text-[#323232]">
//                 Pick a title for the knot you want to travel.
//               </h2>
//             </div>

//             {/* Titles */}
//             <div className="space-y-4 sm:space-y-6 mb-8">
//               {titles.slice(0, 4).map((item, idx) => {
//                 const isActive = selectedTitle === item.title;
//                 return (
//                   <label
//                     key={idx}
//                     className="flex items-center cursor-pointer group"
//                   >
//                     <input
//                       type="radio"
//                       name="titleOption"
//                       value={item.title}
//                       checked={isActive}
//                       onChange={() => handleSelectTitle(item.title)}
//                       className="peer hidden"
//                     />
//                     <div className="w-5 h-5 rounded-full border-2 border-[#666666] flex items-center justify-center peer-checked:border-[#54B0AF] peer-checked:bg-[#54B0AF] transition-all duration-200">
//                       {isActive && (
//                         <div className="w-3.5 h-3.5 rounded-full bg-[#54B0AF] border-[3px] border-white"></div>
//                       )}
//                     </div>
//                     <span
//                       className={`ml-3 font-gotham text-sm sm:text-xl transition-colors ${
//                         isActive
//                           ? "text-[#323232] font-bold"
//                           : "text-[#666666] group-hover:text-[#323232] font-medium"
//                       }`}
//                     >
//                       {item.title}
//                     </span>
//                   </label>
//                 );
//               })}
//             </div>

//             {/* Custom Input */}
//             <div className="mb-6">
//               <textarea
//                 value={customTitle}
//                 onChange={(e) => handleCustomChange(e.target.value)}
//                 placeholder="No one understand your thoughts better than you...."
//                 className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#54B0AF] text-sm resize-none h-24 text-[#323232] font-gotham font-medium sm:text-xl"
//               />
//             </div>

//             {/* Save Button */}
//             <button
//               onClick={handleSave}
//               disabled={!customTitle.trim() && !selectedTitle.trim()}
//               className={`w-full py-3 rounded-xl transition text-white font-bold text-sm sm:text-xl ${
//                 customTitle.trim() || selectedTitle.trim()
//                   ? "bg-[#54B0AF] hover:bg-[#469a99]"
//                   : "bg-[#AAAAAA] text-gray-500 cursor-not-allowed"
//               }`}
//             >
//               Save Title
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TitleSelectionPopup;

// 17-07-2025

import React, { useContext, useState } from "react";
import { UserContext } from "../../../UserContext";
import { X } from "lucide-react";
import PandaTitleSelection from "../../../assets/PandaTitleSelection.png";

const TitleSelectionPopup = ({
  titles = [
    "aPandaTitleSelectionPandaTitleSelection",
    "bPandaTitleSelectionPandaTitleSelection",
    "bPandaTitleSelectionPandaTitleSelection",
    "bPandaTitleSelectionPandaTitleSelection",
  ],
  story_id,
  onClose,
}) => {
  const [customTitle, setCustomTitle] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");
  const { user } = useContext(UserContext);

  const handleSave = async () => {
    const finalTitle = customTitle.trim() || selectedTitle.trim();
    if (!finalTitle) return;
    updateTitle(finalTitle);
    onClose(finalTitle);
  };

  const updateTitle = async (title) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_selected_title`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userid: user.user_id,
            story_id: story_id,
            chapter_id: null,
            title: title,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Failed to update title:", errorData.detail || errorData);
        return;
      }

      const result = await response.json();
      console.log("Title updated successfully:", result);
    } catch (error) {
      console.error("Error updating title:", error);
    }
  };

  const handleCustomChange = (val) => {
    setCustomTitle(val);
    setSelectedTitle("");
  };

  const handleSelectTitle = (title) => {
    setSelectedTitle(title);
    setCustomTitle("");
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center p-2 sm:p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-[90vw] md:max-w-[940px] max-h-[90vh] md:max-h-[640px] relative overflow-hidden">
        {/* Close icon */}
        <button
          onClick={() => onClose("")}
          className="absolute top-4 right-4 text-gray-500 font-bold hover:text-gray-600 z-10"
        >
          <X size={20} className="font-bold" />
        </button>

        <div className="flex flex-col md:flex-row h-full">
          {/* Left - Panda */}
          <div className="w-full md:w-[310px] h-[180px] md:h-[640px] bg-gray-100 rounded-t-2xl md:rounded-l-2xl md:rounded-tr-none flex items-center justify-center p-4 md:p-8 relative">
            <img
              src={PandaTitleSelection}
              alt="Panda Illustration"
              className="w-full h-full left-0 bottom-0 absolute max-w-[300px] md:max-w-[340px] max-h-[180px] md:max-h-[550px] object-contain md:object-cover"
            />
          </div>

          {/* Right content */}
          <div className="flex-1 p-4 md:p-8 overflow-y-auto max-h-[calc(100vh-220px)] md:max-h-[640px] scrollbar-hide">
            {/* Header */}
            <div className="mb-6 md:mb-8 border-b-[2px] md:border-b-[3px] pb-4 md:pb-6 border-[#CACACA]">
              <h2 className="text-lg md:text-2xl font-gotham font-medium text-[#323232]">
                Pick a title for the knot you want to untangle.
              </h2>
            </div>

            {/* Titles */}
            <div className="space-y-3 md:space-y-8 mb-6 md:mb-8">
              {titles.slice(0, 4).map((item, idx) => {
                const isActive = selectedTitle === item.title;
                return (
                  <label
                    key={idx}
                    className="flex items-center cursor-pointer group"
                  >
                    <input
                      type="radio"
                      name="titleOption"
                      value={item.title}
                      checked={isActive}
                      onChange={() => handleSelectTitle(item.title)}
                      className="peer hidden"
                    />
                    <div className="w-4 h-4 md:w-5 md:h-5 rounded-full border-2 border-[#666666] flex items-center justify-center peer-checked:border-[#54B0AF] peer-checked:bg-[#54B0AF] transition-all duration-200">
                      {isActive && (
                        <div className="w-2.5 h-2.5 md:w-3.5 md:h-3.5 rounded-full bg-[#54B0AF] border-[2px] md:border-[3px] border-white"></div>
                      )}
                    </div>
                    <span
                      className={`ml-2 md:ml-3 font-gotham text-sm md:text-xl transition-colors ${
                        isActive
                          ? "text-[#323232] font-bold"
                          : "text-[#666666] group-hover:text-[#323232] font-medium"
                      }`}
                    >
                      {item.title}
                    </span>
                  </label>
                );
              })}
            </div>

            {/* Custom Input */}
            <div className="mb-4 md:mb-6">
              <textarea
                value={customTitle}
                onChange={(e) => handleCustomChange(e.target.value)}
                placeholder="Choose your own title for this knot..."
                className="w-full px-3 py-2 md:px-4 md:py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#54B0AF] text-sm resize-none h-24 text-[#323232] font-gotham font-medium md:text-xl"
              />
            </div>

            {/* Save Button */}
            <button
              onClick={handleSave}
              disabled={!customTitle.trim() && !selectedTitle.trim()}
              className={`w-full py-2 mb-6 md:mb-0 md:py-3 rounded-xl transition text-white font-bold text-sm md:text-xl ${
                customTitle.trim() || selectedTitle.trim()
                  ? "bg-[#54B0AF] hover:bg-[#469a99]"
                  : "bg-[#AAAAAA] text-gray-500 cursor-not-allowed"
              }`}
            >
              Save Title
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TitleSelectionPopup;
